import styled from 'styled-components';

export const PopoverContainer = styled.div`
  max-block-size: 32rem;
  min-inline-size: 38rem;
  overflow-y: auto;
`;
